import type { Permission } from '@jaf/contracts';
import { useCallback } from 'react';
import { useSession } from '@/features/auth';
import { useCompanyScope } from '@/features/company-scope';
import { canInEveryCompany, canInScope } from './can';

/** Pergunta de permissão: `can('ledger-entries:create')`. */
export type CanFunction = (permission: Permission) => boolean;

/**
 * Devolve `can(permissão)`, reativo à sessão e ao escopo do cabeçalho, para esconder menus,
 * botões e telas sem a permissão no escopo selecionado.
 */
export function useCan(): CanFunction {
  const session = useSession((state) => state.session);
  const { companyIds } = useCompanyScope();
  return useCallback(
    (permission) => canInScope(session, permission, companyIds),
    [session, companyIds],
  );
}

/**
 * Indica se a permissão vale em todas as empresas informadas, independente do escopo do
 * cabeçalho (ex.: anexar exige `titles:create` na empresa do título e nas do rateio).
 */
export function useCanInCompanies(permission: Permission, companyIds: readonly string[]): boolean {
  const session = useSession((state) => state.session);
  return canInEveryCompany(session, permission, companyIds);
}
